/**
 * API calls of the shop file's numbering tab, on the generated `InternalAdminApi`.
 *
 * Both carry the shop's access grant (`shopGrant`) — the READ included: the shop's counters are
 * its data like any other. A refusal for want of a grant is recognised by `isShopAccessRequired`
 * in the caller, which then asks for a reason again.
 */

import type {
  ShopNumberingDto,
  UpdateShopNumberingDto,
  UpdateShopNumberingResponseDto,
} from '../../../../libs/api-client/src/generated/models';
import { opsClient, shopGrant } from './ops-api';

// Re-exported from the generated client rather than restated here — see `support-api.ts`.
export type {
  ShopNumberingDto as ShopNumbering,
  ShopNumberSequenceDto as ShopNumberSequence,
  UpdateShopNumberingResponseDto as UpdateShopNumberingResponse,
} from '../../../../libs/api-client/src/generated/models';

/** The shop's numbering state: counters, prefixes, year flag and what issued documents lock. */
export async function fetchShopNumbering(
  shopId: string,
): Promise<ShopNumberingDto> {
  const { data } = await opsClient().getShopNumbering({
    shopId,
    xOpsShopAccess: shopGrant(shopId),
  });
  return data;
}

/** Applies a numbering change. The API re-checks every rule under a lock on the shop row. */
export async function updateShopNumbering(
  shopId: string,
  body: UpdateShopNumberingDto,
): Promise<UpdateShopNumberingResponseDto> {
  const { data } = await opsClient().updateShopNumbering({
    shopId,
    xOpsShopAccess: shopGrant(shopId),
    updateShopNumberingDto: body,
  });
  return data;
}
